var axios = require('axios');

module.exports = axios.create({
  baseURL: 'https://code2m.com.br/api/index.php/',
  timeout: 25000, 
});


